import { Box, type BoxProps } from '@mui/material';

import { NavListItem } from '.';

import type { FC } from 'react';

interface NavItemProps {
  title: string;
  path: string;
  icon?: JSX.Element;
  info?: JSX.Element;
  children?: Array<{
    title: string;
    path: string;
  }>;
}

interface NavListProps extends BoxProps {
  subNavConfig: Array<
    {
      subheader: string;
      isActiveSub: boolean;
      items: NavItemProps[];
    } & NavItemProps
  >;
}

export const NavList: FC<NavListProps> = ({ subNavConfig, ...other }) => (
  <Box
    // component="ul"
    sx={{
      // Root
      position: 'relative',
      /* '&:before': {
        top: 0,
        bottom: 0,
        height: 0.96,
        my: 'auto',
        left: 20,
        width: '1px',
        content: "''",
        bgcolor: 'divider',
        position: 'absolute',
      }, */
      '& .MuiListSubheader-root': { mb: 1 },
      '& .MuiListItemButton-root': {
        backgroundColor: 'transparent',
        '&:before': { display: 'none' },
      },
      // Sub
      '& .MuiCollapse-root': {
        '& .MuiList-root': {
          '&:before': {
            top: 0,
            bottom: 0,
            left: 40,
            my: 'auto',
            height: 0.82,
            width: '1px',
            content: "''",
            bgcolor: 'divider',
            position: 'absolute',
          },
        },
        '& .MuiListItemButton-root': {
          pl: 8,
          '& .MuiListItemIcon-root, .MuiTouchRipple-root': { display: 'none' },
          '&:hover': { backgroundColor: 'transparent' },
        },
      },
    }}
    {...other}
  >
    {subNavConfig.map((item) => (
      <NavListItem key={item.subheader} {...item} />
    ))}{' '}
    {/*  <List key={list.subheader} disablePadding sx={{ px: 0 }}> */}
  </Box>
);
